const MAKE_CODES = {
  "Abarth": "ABAR",
  "A C": "AC",
  "Acadian (GM of Canada)": "ACAD",
  "Acura": "ACUR",
  "Adette": "ADET",
  "Aerocar": "AERA",
  "Aero": "AERO",
  "Aeta": "AETA",
  "Alfa Romeo": "ALFA",
  "Allard": "ALLA",
  "Allison's Fiberglass Mfg., Inc": "ALLF",
  "All State": "ALLS",
  "Alma": "ALMA",
  "Alphine": "ALPI",
  "Alta": "ALTA",
  "Alvis": "ALVI",
  "American Motors": "AMER",
  "Amphicar": "AMPH",
  "Argonaut State Limousine": "ARGO",
  "Arista": "ARIT",
  "Armstrong Siddeley": "ARMS",
  "Arnolt-Bristol": "ARNO",
  "Ascort": "ARSC",
  "ASA": "ASA",
  "Ashley": "ASHL",
  "Aston-Martin": "ASTO",
  "Asuna": "ASUN",
  "Assembled Vehicle": "ASVE",
  "Auburn": "AUBU",
  "Audi": "AUDI",
  "Austin-Healy": "AUHE",
  "Autokraft": "AUKR",
  "Aurora": "AURR",
  "Austin": "AUST",
  "Autobianchi": "AUTA",
  "Autobieu": "AUTB",
  "Autocar": "AUTO",
  "Autocarrier and A.C.": "AUTR",
  "Auto Union": "AUTU",
  "Avenger": "AVEN",
  "Avia": "AVIA",
  "Avanti": "AVTI",
  "Beardmore": "BEAD",
  "Bedford": "BEDF",
  "Bentley": "BENT",
  "Bergantine": "BERG",
  "Berkley": "BERK",
  "Berotone": "BERO",
  "Bitter": "BITT",
  "Bizzarrini": "BIZZ",
  "BMC": "BMC",
  "BMW": "BMW",
  "Bantam": "BNTM",
  "Bobbi- Kar": "BOBB",
  "Bocar": "BOCA",
  "Bond": "BOND",
  "Borgward": "BORG",
  "Brasinca": "BRAS",
  "Bradley GT": "BRDL",
  "Breman Sport Equipment, Inc.": "BREM",
  "Bricklin": "BRIC",
  "Bristol": "BRIS",
  "Bugatti": "BUGA",
  "Buick": "BUIC",
  "Butterfield Musketeer": "BUTT",
  "B & Z Electric Car Co.": "BZEL",
  "Cadillac": "CADI",
  "Capri": "CAP",
  "Chaika": "CHAI",
  "Checker": "CHEC",
  "Chevrolet": "CHEV",
  "Ching - Kan - Shan": "CHIN",
  "Chrysler": "CHRY",
  "Cisitalia": "CISI",
  "Citicar": "CITI",
  "Citroen": "CITR",
  "Classic Roadsters, Ltd.": "CLAC",
  "Classic Motor Carriages, Inc.": "CLAI",
  "Clenet Coach Works": "CLEN",
  "Clua": "CLUA",
  "AC Cobra": "COBR",
  "Conceptor Industries Inc.": "COCP",
  "Commuter Vehicle": "COMV",
  "Connaught": "CONN",
  "Contessa": "CONS",
  "Consulier": "CONU",
  "Cooper": "COOP",
  "Cord": "CORD",
  "Crofton Cub": "CROF",
  "Crosley": "CROS",
  "Cubster": "CUBS",
  "Cunningham": "CUNN",
  "Daewoo": "DAEW",
  "DAF": "DAF",
  "Daihatsu": "DAIH",
  "Daimler": "DAIM",
  "D & A Vehicles, Inc.": "DAIN",
  "Datsun": "DATS",
  "Davis": "DAVI",
  "Daytona": "DAYO",
  "D.B.": "DB",
  "Debonair": "DEBO",
  "DeCourville": "DECO",
  "Deep Sanderson": "DEEP",
  "Dellow": "DELL",
  "De Lorean": "DELO",
  "Denzel": "DENZ",
  "DeSoto": "DESO",
  "DeTomaso": "DETO",
  "Di Tella": "DITE",
  "Diva": "DIVA",
  "DKW": "DKW",
  "Dodge": "DODG",
  "Dong Feng": "DONG",
  "Duel": "DUEL",
  "Duesenberg": "DUES",
  "Durant": "DURA",
  "Edsel": "EDSE",
  "Eagle": "EGIL",
  "Elva": "ELVA",
  "Electric Vehicle Corp.": "ELVC",
  "EMW": "EMW",
  "English Ford": "ENGF",
  "Envoy": "ENVY",
  "Enzmann": "ENZM",
  "Erskine": "ERSK",
  "Eshelman Sportabout": "ESHL",
  "Essex": "ESSE",
  "Everybody's Motor Car Mfg.": "EVRY",
  "Excalibur": "EXCL",
  "Facel - Vega": "FACE",
  "Facellia": "FACL",
  "Fairthorpe": "FAIR",
  "Falcon": "FALC",
  "Felber": "FELB",
  "Ferrari": "FERR",
  "Fiat - Abarth": "FIAA",
  "Fiat": "FIAT",
  "Fiberfab, Inc.": "FIBE",
  "Fiesta": "FIST",
  "FNM": "FNM",
  "Ford": "FORD",
  "Franklin": "FRAN",
  "Frazier": "FRAZ",
  "French Ford": "FREF",
  "Frisky": "FRIS",
  "Frazer - Nash": "FRNA",
  "GAZ": "GAZ",
  "GEO": "GEO",
  "Giannini": "GIAN",
  "Gilbern": "GILB",
  "Ginetta": "GINE",
  "Gitane": "GITA",
  "Glas": "GLAS",
  "Glassic": "GLSC",
  "General Motors": "GMC",
  "Goliath": "GOLI",
  "Gordon": "GORD",
  "Graciela": "GRAC",
  "Graham": "GRAH",
  "Graham - Paige": "GRAP",
  "Griffith": "GRIF",
  "GSM": "GSM",
  "Heinkel": "HEIN",
  "Henry J.": "HENR",
  "Hickey Trail - Blazer": "HICK",
  "Hillman": "HILL",
  "Hindustan": "HIND",
  "Hino": "HINO",
  "Holden": "HOLD",
  "Honda": "HOND",
  "Hongki or Hong - Chi": "HONG",
  "Horch Limousine": "HORC",
  "Hotchkins": "HOTC",
  "HRG": "HRG",
  "Hudson": "HUDS",
  "Humber": "HUMB",
  "Humbee Surrey": "HUME",
  "Hupmobile": "HUPM",
  "Hyundai": "HYUN",
  "I.A.M.E.": "IAME",
  "I.K.A.": "IKA",
  "I.M.P.": "IMPB",
  "Imperial": "IMPE",
  "Infiniti": "INFI",
  "Intermeccanica": "INME",
  "Innocenti": "INNO",
  "Isetta": "ISET",
  "ISO": "ISO",
  "Isuzu": "ISU",
  "Italian Ford": "ITAF",
  "Italia": "ITAI",
  "Jaguar": "JAGU",
  "Jenson": "JENS",
  "Jetmobile": "JETM",
  "Jowett": "JOWE",
  "Kaiser": "KAIS",
  "Kia Motors Corporation": "KIA",
  "King Midget": "KIMI",
  "Kurtis Kraft": "KURT",
  "Lada": "LADA",
  "Lagonda": "LAGO",
  "LaSalle": "LALL",
  "Lamborghini": "LAMO",
  "Lanchester": "LANC",
  "Laser": "LASE",
  "Lea - Francis": "LEAF",
  "Lexus": "LEXS",
  "Lincoln - Continental": "LINC",
  "Lloyd": "LLOY",
  "Lancia": "LNCI",
  "Locomobile": "LOCO",
  "Lola": "LOLA",
  "London Motors": "LOND",
  "Loodcraft": "LOOD",
  "Lotus": "LOTU",
  "Modena": "MDNA",
  "Merkur": "MERK",
  "Messerschmitt": "MESS",
  "Meteor": "METE",
  "Metropolitan": "METR",
  "MG": "MG",
  "Mikasa": "MIKA",
  "Mikrus": "MIKR",
  "Mistral": "MIST",
  "Mitsubishi": "MITS",
  "Model A & Model T Motor Car": "MODE",
  "Monarch": "MONA",
  "Moretti": "MORE",
  "Morgan": "MORG",
  "Morris": "MORR",
  "Moskovitch": "MOSK",
  "Muntz": "MUNT",
  "Murena": "MURE",
  "Mzma": "MZMA",
  "Mardi - Danese": "NARD",
  "Nash": "NASH",
  "Peerless": "PEER",
  "Pegaso": "PEGA",
  "Peugeot": "PEUG",
  "Phoenix": "PHOE",
  "Pinifarina": "PINI",
  "Playboy": "PLAY",
  "Plymouth": "PLYM",
  "Poirier": "POIR",
  "Pontiac": "PONT",
  "Porsche": "PORS",
  "Prairie Schooner": "PRAI",
  "Pierce Arrow": "PRCA",
  "Prince Motors": "PRMO",
  "Progress": "PROG",
  "PTV": "PTV",
  "Puch": "PUCH",
  "Puma": "PUMM",
  "Rambler": "RAMB",
  "Ramses": "RAMS",
  "Reliant": "RELA",
  "Renault": "RENA",
  "Reo": "REO",
  "Riley": "RILE",
  "Rich Industries": "RIND",
  "Rochdale": "ROCH",
  "Rockne": "ROK",
  "Rolls - Royce": "ROL",
  "Rootes": "ROOT",
  "Rover": "ROV",
  "Rycsa": "RYCS",
  "SAAB": "SAA",
  "Sabra": "SABR",
  "Saturn Corporation": "SATR",
  "Seat": "SEAT",
  "Sera": "SERA",
  "Shelby American": "SHEB",
  "Siata": "SIAT",
  "Sila Autoretta": "SILA",
  "Simca": "SIM",
  "Singer": "SIN",
  "Skoda": "SKOD",
  "Sovam": "SOVA",
  "Standard": "STAN",
  "Star": "STAR",
  "Steyr - Puch": "STEY",
  "Sterling": "STLG",
  "Strale": "STRA",
  "Saturn": "STRN",
  "Studebaker": "STU",
  "Stutz": "STUZ",
  "Subaru": "SUBA",
  "Sunbeam": "SUNB",
  "Super Two": "SUPT",
  "Suzuki": "SUZI",
  "Suzulight Su": "SUZU",
  "Syrena": "SYRE",
  "Tama": "TAMA",
  "Tatra": "TATR",
  "Taunus": "TAUN",
  "Tchaika": "TCHA",
  "Tjaarda": "TJAA",
  "Tornado": "TORN",
  "Toyopet": "TOYP",
  "Toyota": "TOYT",
  "Trabant": "TRAB",
  "Triumph": "TRIU",
  "Trojan": "TROJ",
  "Terraplane": "TRPE",
  "Triumph Motor Co.": "TRUM",
  "Tucker": "TUCK",
  "Turner": "TURN",
  "TVR": "TVR",
  "TZ": "TZ",
  "Unicar": "UNIC",
  "Unipower": "UNIP",
  "U.S.Electricar Corp.": "USEL",
  "Vector Aeromotive Corp.": "VACR",
  "VAL": "VAL",
  "Valkrie": "VALK",
  "Vanguard": "VANG",
  "Vauxhall": "VAUX",
  "Veritas": "VERI",
  "Vespa": "VESP",
  "Vanden Plas": "VNDN",
  "Volga": "VOGA",
  "Volkswagen": "VOLK",
  "Volvo": "VOLV",
  "Warszawa": "WARS",
  "Wartburg": "WART",
  "Warwick": "WARW",
  "Watford": "WATF",
  "Wendex": "WEND",
  "Whippet": "WHIP",
  "Wilson": "WILS",
  "Willys": "WLLS",
  "Wolseley": "WOLS",
  "Woodill Wildfire": "WOOD",
  "Worthington Champ": "WORT",
  "Yenko": "YENK",
  "YLN": "YLN",
  "Zaporozhets": "ZAPO",
  "Zar Car": "ZARC",
  "Zastavia": "ZCZY",
  "Zeta": "ZETA",
  "Zil": "ZIL",
  "Zim": "ZIM",
  "Zimmerman Automobiles": "ZIMR",
  "Zundapp": "ZUND",
  "Zwickau": "ZWIC",
}

export const returnMakeCode = (make) => {
  return MAKE_CODES[make] || null;
}